var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlameLevel1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.02 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0ba1e2;}.cls-2{fill:#dbdbdb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flame level 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,51.15c8.45-2.35,12.35-9.48,13.13-16a24.32,24.32,0,0,0-2-12.08c0,1.25-1.49,3.57-3.12,4.81a5.18,5.18,0,0,1-2.65,1C39.07,5.77,16,0,16,0c11.54,17.32-4.07,18.79-9.3,29.08C1.18,39.89,8.59,48.72,17,51.24,20.07,52,25.48,52,28,51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.19,64H1.83a1.83,1.83,0,1,1,0-3.66H44.19a1.83,1.83,0,1,1,0,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.62,62.17c0-1-2.84-1.83-1.83-1.83h-4a1.83,1.83,0,1,0,0,3.66h4C4.78,64,7.62,63.18,7.62,62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.23,60.34H3.05c1,0-.61.82-.61,1.83S4.06,64,3.05,64H8.23a1.83,1.83,0,1,0,0-3.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameLevel1);
export default __webpack_public_path__ + "static/media/Flame_level_1.6bcf522619ce2ca9e910e596ebc7dce4.svg";
export { ForwardRef as ReactComponent };